import React from 'react';
import { IonIcon } from '@ionic/react';
import './HeaderCounterIcon.css';

interface Props {
  icon: string;
  count?: number;
}

const HeaderCounterIcon: React.FC<Props> = ({ icon, count }) => (
  <span className="xeguei-header-counter">
    <IonIcon icon={icon} aria-hidden="true" />
    {count !== undefined && <span className="xeguei-header-counter-value">{count}</span>}
  </span>
);

export default HeaderCounterIcon;
